import {
    GET_REQUESTED_TMS,
    SET_PAGE,
    SET_ROWS_PER_PAGE,
    SET_SELECTED_ROW,
    SET_REPORT_EDIT_STATUS,
    SET_STATUS_CHANGE_MODAL_INFO,
    DELETE_REPORT,
    SET_DELETE_STATUS,
    GET_TMPLAN_TMS,
    GET_REQUESTED_ENDPOINTS
} from "./types";

const INITIAL_STATE = {
    requestingTitles: false,
    requestingUserData: false,
    requestedTMPlans: false,
    plans: [],
    userUid: "all_users",
    endpoints: false,

    rowsPerPage: 50,
    page: 1,
    postingReportStatus: false,
    selectedRow: false,
    postingReportEditStatus: false,

    deletedStatus: { deleteSuccess: false, deleteFail: false },
    deletingReport: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_TMPLAN_TMS: {
            return { ...state,
                plans: action.payload}
        }
        
        case GET_REQUESTED_TMS.REQUEST: {
            return {
                ...state,
                requestingUserData: true,
                requestedTMPlans: false
            };
        }
        case GET_REQUESTED_TMS.FAIL: {
            return {
                ...state,
                requestingUserData: false,
                requestedTMPlans: false
            };
        }
        case GET_REQUESTED_TMS.SUCCESS: {
            return {
                ...state,
                requestingUserData: false,
                requestedTMPlans: action.payload
            };
        }

        case SET_ROWS_PER_PAGE: {
            return { ...state, rowPerPage: action.payload };
        }
        case SET_PAGE: {
            return { ...state, page: action.payload };
        }

        case SET_SELECTED_ROW: {
            return { ...state, selectedRow: action.payload };
        }
        case SET_REPORT_EDIT_STATUS.REQUEST: {
            return { ...state, postingReportEditStatus: true };
        }
        case SET_REPORT_EDIT_STATUS.FAIL: {
            return { ...state, postingReportEditStatus: false };
        }
        case SET_REPORT_EDIT_STATUS.SUCCESS: {
            return { ...state, postingReportEditStatus: false };
        }
        case SET_STATUS_CHANGE_MODAL_INFO: {
            return { ...state, changeReportStatusModal: action.payload };
        }
        case DELETE_REPORT.REQUEST: {
            return {
                ...state,
                deletingReport: true,
                deletedStatus: { deleteSuccess: false, deleteFail: false }
            };
        }
        case DELETE_REPORT.FAIL: {
            return {
                ...state,
                deletingReport: false,
                deletedStatus: { deleteSuccess: false, deleteFail: true }
            };
        }
        case DELETE_REPORT.SUCCESS: {
            return {
                ...state,
                deletingReport: false,
                deletedStatus: { deleteSuccess: true, deleteFail: false }
            };
        }
        case SET_DELETE_STATUS: {
            return {
                ...state,
                deletedStatus: { deleteSuccess: false, deleteFail: false }
            };
        }

        case GET_REQUESTED_ENDPOINTS.REQUEST: {
            return { ...state, requesting: true, endpoints: false };
        }
        case GET_REQUESTED_ENDPOINTS.SUCCESS: {
            return { ...state, requesting: false, endpoints: action.payload };
        }
        case GET_REQUESTED_ENDPOINTS.FAIL: {
            return { ...state, requesting: false, endpoints: false };
        }

        default: {
            return state;
        }
    }
};
